/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// core-js is normally required because it adds polyfills, but the
// UI Library imports babel/polyfill, and using both of these results in a 
// stack overflow in IE11. 
// import 'core-js/stable'
import 'regenerator-runtime/runtime'

// third party
import Url from 'domurl';
window.Url = Url;


import {translations} from 'src/translations.js.erb'
window.translations = translations;

import routes from 'src/routes'
window.routes = routes;

import {Fields} from 'src/search/fields';
window.Fields = Fields;

import LocationSearch from 'src/search/location_search';
window.LocationSearch = LocationSearch;

import {MapPositionStorage} from 'src/search_results/map_position_storage';
window.MapPositionStorage = MapPositionStorage;

import {searchForm} from 'src/listings/search_form.js';
window.searchForm = searchForm;

import {addressSearch} from 'src/search/address_search';
import {advancedAddressSearch} from 'src/search/advanced_address_search';
import {mlsNumberSearch} from 'src/search/mls_number_search';

import {initIdxLinks} from 'src/idx_links';
import {initContactsCollections} from 'src/contacts_collections';
import {initListingHistory} from 'src/listing_history';

import {addToCollectionModal} from 'src/add_to_collection_modal';
import {selectListings} from 'src/select_listings';

import { nativeAppInterface } from 'src/native_app_interface';
window.nativeAppInterface = nativeAppInterface;

window.Stimulus = Application.start()
const context = require.context("../src/controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

window.addEventListener('DOMContentLoaded', (e) => {

  if(document.querySelector('.addressSearchContent')) {
    addressSearch.init();
  }

  if(document.querySelector('.advancedAddressSearchContent')) {
    advancedAddressSearch.init();
  }

  if(document.querySelector('.mlsNumberSearchContent')) {
    mlsNumberSearch.init();
  }

  if(document.querySelector('#idx-links-list')) {
    initIdxLinks();
  }

  if(document.querySelector('#contacts-collections-list')) {
    initContactsCollections();
  }

  if(document.querySelector('#listingChangesList')) {
    initListingHistory();
  }

  if(document.querySelector('#addToCollectionModal')){
    addToCollectionModal.init('#addToCollectionModal');
  }

  selectListings.checkCurrentUser();

});
